import React, { Component } from 'react';
import { observer } from 'mobx-react';

import _ from 'lodash';

import { RequestState } from '../stores/requests';
import { ProviderApi, RequestApi, StockApi } from '../stores/apiMethods';
import { uistate, confirmState } from '../stores/common';

import { CreateButton, ItemNewHeader, RemoveIconButton } from '../shared/PageComponents';
import { Selectize, TextInput } from '../forms/FormItems';
import { CheckBoxGroup } from '../shared/FormElements';
import { TablePageContent } from '../shared/TableComponents';
import { OpenShiftInformer } from '../shared/FeedbackComponents';

import { toSelectList, formatDate, setUnit } from '../functions';

export class RequestsPage extends Component {
	constructor(props) {
		super(props);

		this.store = new RequestState ();
	}
	
	componentDidMount () {
		ProviderApi.getList(true, (data) => {
			this.store.Providers = data.Success ? data.Providers : [];
		});
		
		this.getData();
	}

	/** API запрос «Requests» на получение заявок */
	getData() {
		this.store.IsSendRequest = false;
		RequestApi.getList((data) => { this.store.setRequests(data); })
	}

	/**
	 * Выбор нужной заявки
	 * @param {number} id ID заявки
	 * @param {string} type тип просмотра — new, view, process
	 */
	setId = (id, type) => {
		if (_.isNumber(id) || _.isString(id)) {
			if (id !== -1) 
				this.store.setRequest(_.find(this.store.Requests, { Id: id }), type);
			else this.store.setRequest({ Id: -1 }, "new");
		} else {
			this.store.setRequest();
			this.getData();
		}
	}

	/**
	 * API запрос «RemoveRequest» на удаление заявки
	 * @param {number} id ID заявки
	 */
	removeId = (id) => {
		if (_.isUndefined(id)) return false;

		var item = _.find(this.store.Requests, { Id: id }),
			text = <span>Вы действительно хотите удалить заявку от&nbsp;
				<b key="b1">«{item ? formatDate(item.Date) : ""}»</b>?</span>;

		confirmState.openConfirm(text, () => {
			RequestApi.remove(id, () => { this.getData(); })
		});
	}

	render() {
		return (
			<div className="page" id="RequestsPage">
				{_.isUndefined(this.store.Request) ?
					<>
						<div className={"head " + (uistate.IsMobile ? "mobile" : "")}>
							<h2>Заказ</h2>
							{this.store.CanManage && 
								<CreateButton Title="Создать заявку" onClick={() => this.setId(-1)} />
							}
						</div>
						{!this.store.CanManage &&
							<OpenShiftInformer Text="Для формирования заявки на закупку откройте смену" />
						}
						<TablePageContent
							TableData={this.store.Requests}
							TableColumns={this.store.columns}
							TableFilterable={true}

							setId={this.setId}
							removeId={this.removeId}

							getTrProps={(state, rowInfo, column) => {
								return { className: rowInfo && rowInfo.original.Status !== 1 ? "notactive" : "" };
							}}
						/>
					</> :
						<RequestItem 
							Request={this.store.Request}
							Stocks={this.store.Stocks}
							getProvidersByProduct={this.store.getProvidersByProduct}
							setId={this.setId}
					/>
				}
			</div>
		)
	}
}
RequestsPage = observer(RequestsPage);

class RequestItem extends Component {
	constructor(props) {
		super(props);

		if (this.props.Request.Id !== -1)
			this.getActual(this.props.Request.StockId);
		else if (this.props.Request.StockId > 0)
			this.getStock(this.props.Request.StockId);
	}

	/** API запрос «Stock» на получение настроек склада 
	 * @param {number} id ID склада
	 */
	getStock(id) {
		StockApi.getById(id, true, (data) => {
			this.props.Request.setTemplate(data.Success ? data.Products : [])
		});
	}

	/** API запрос «StockActual» на получение остатков склада 
	 * @param {number} id ID склада
	 */
	getActual(id) {
		StockApi.getActual(id, (data) => {
			this.props.Request.Products.setActuals(data.Success ? data.Products : [])
		});
	}

	/** Формирование продуктов новой заявки и загрузка актуальных остатков */
	handleStart = () => {
		this.props.Request.startRequest();
		this.getActual(this.props.Request.StockId);
	}

	/** API запрос «NewRequest»/«ProcessRequest» на создание/обработку */
	handleSubmit = (event) => {
		event.preventDefault();

		if (!this.props.Request.validate()) return false;

		this.props.Request.ButtonLoading = true;

		const request = this.props.Request.ProcessMode
			? RequestApi.process
			: RequestApi.create;

		request(this.props.Request.getData(), (data) => {
			if (data.Success) this.props.setId();
			else this.props.Request.ErrorCode = data.ErrorCode;

			this.props.Request.ButtonLoading = false;
		});
	}

	/**
	 * Сбор данных с формы заявки
	 * @param {number} value значение параметра
	 * @param {string} id название параметра
	 */
	handleChange(value, id) {
		this.props.Request.collect(id, value);

		if (/StockId/.test(id)) {
			this.getStock(value);
		}
	}

	render() {
		return (
			<section className={"item " + (uistate.IsTablet ? "tablet" : "")} id="RequestItem">
				<form onSubmit={this.handleSubmit}>
					<ItemNewHeader
						Title={this.props.Request.PageTitle}
						ErrorCode={this.props.Request.ErrorCode}
						ButtonLoading={this.props.Request.ButtonLoading}
						CanManage={this.props.Request.CanManage}
						handleClose={this.props.setId}
					/>
					<div className="section main">
						<Selectize
							Id="StockId"
							Title="Склад"
							List={toSelectList(this.props.Request.CreateMode
								? this.props.Stocks
								: [{ Id: this.props.Request.StockId, Name: this.props.Request.StockName }])}
							Value={this.props.Request.StockId}
							Disabled={!this.props.Request.CanChange}
							isSearchable={false}
							isClearable={false}
							onChange={this.handleChange.bind(this)}
						/>
						<Selectize
							Id="TemplateType"
							Title="Тип заявки"
							List={toSelectList(this.props.Request.Templates)}
							Value={this.props.Request.TemplateType}
							Disabled={!this.props.Request.CanChange}
							isSearchable={false}
							isClearable={false}
							onChange={(value, id) => this.props.Request.collect(id, value)}
						/>
						{this.props.Request.TemplateMode && this.props.Request.Template && this.props.Request.Template.CanStart &&
							<button type="button" className='secondary' onClick={this.handleStart}>Начать формировать заявку</button>
						}
					</div>
					{this.props.Request.TemplateMode && this.props.Request.Template &&
						<TemplateProductsBlock Template={this.props.Request.Template} />
					}
					{!_.isEmpty(this.props.Request.Products.List) && !this.props.Request.TemplateMode &&
						<RequestProductsBlock 
							Products={this.props.Request.Products} 
							getProvidersByProduct={this.props.getProvidersByProduct}
						/>
					}
				</form>
			</section>
		)
	}
}
RequestItem = observer(RequestItem);

class TemplateProductsBlock extends Component {
	render () {
		if (this.props.Template.Type !== 2) return null
		
		return(
			<>
				{_.map(this.props.Template.Products, (type, i) => {
					return(<div className="section block type" key={i}>
						<h4>{type.Name}</h4>
						{_.map(type.Sections, (section, k) => {
							return(
								<CheckBoxGroup key={k}
									Id={"Checked_" + section.SectionId}
									Title={section.SectionName}
									CanGroup={true}
									List={section.Products}
									RowClass="nomargin"
									Value={this.props.Template.Checked}
									ParseType="number"
									onChange={(value, id) => this.props.Template.collect(value)}
								/>
							)
						})}
					</div>)
				})}
			</>
		)
	}
}
TemplateProductsBlock = observer(TemplateProductsBlock);

class RequestProductsBlock extends Component {
	render() {
		return (
			<>
				<div className='section search'>
					<TextInput
						Id="Filter"
						Title="Поиск по продуктам"
						Value={this.props.Products.Filter}
						RowClass="search"
						onChange={(value, id) => this.props.Products.collect(id, value)}
					/>
				</div>
				{_.map(this.props.Products.Types, (type, i) => {
						return (<RequestProductType key={"t" + i}
							Item={type} Index={i} 
							removeProduct={this.props.Products.remove}
							getProvidersByProduct={this.props.getProvidersByProduct}
						/>)
				})}
			</>
		)
	}
}
RequestProductsBlock = observer(RequestProductsBlock);

class RequestProductType extends Component {
	render() {
		return (
			<div className="section productBlock">
				<h4>{this.props.Item.TypeName}</h4>
				<div className="table">
					<>
						<span className="title">Название</span>
						<span className="title">Мин. кол-во</span>
						<span className="title" title="Остаток в программе">Остаток в программе</span>
						<span className="title" title="Фактически на складе">Факт. на складе</span>
							{this.props.Item.ProcessMode ?  <span className="title">Заказ</span> : <span></span>}
							{this.props.Item.ProcessMode ? <span className="title">Поставщик</span> : <span></span>}
						<span></span>
					</>
					{_.map(this.props.Item.Sections, (section, i) => {
						return (<RequestProductGroup key={"s" + i}
								Item={section}
								Index={i}
								removeProduct={this.props.removeProduct}
								// Type={this.props.Index}
								getProvidersByProduct={this.props.getProvidersByProduct}
					/>)
					})}
				</div>
			</div>
		)
	}
}
RequestProductType = observer(RequestProductType);

class RequestProductGroup extends Component {
	render() {
		return (
			<>
				<h5>{this.props.Item.SectionName}</h5>
				{_.map(this.props.Item.Products, (product, i) => {
						return (<RequestProductItem key={i}
							Item={product} Index={i} 
							removeProduct={this.props.removeProduct}
						// Type={this.props.Type}
						// Section={this.props.Index} 
								getProvidersByProduct={this.props.getProvidersByProduct}
						/>
						)
				})}
			</>
		)
	}
}
RequestProductGroup = observer(RequestProductGroup);

class RequestProductItem extends Component {
	render() {
		return (
			<>
				<span>{this.props.Item.Product}</span>
				<span>{setUnit(this.props.Item.StockCount, this.props.Item.UnitName)}</span>
				<span>
					{setUnit(this.props.Item.Actual, this.props.Item.UnitName)},
					<i className="date">{formatDate(this.props.Item.LastUpdate)}</i>
				</span>
					{this.props.Item.CreateMode ?
					<TextInput
						Id="Count"
						Value={this.props.Item.Count}
						Type="number"
						Step="0.001"
						RowClass="nomargin"
						onChange={(value, id) => this.props.Item.collect(id, value)}
					/>
					: <span>{setUnit(this.props.Item.Count, this.props.Item.UnitName)}</span>
				}
					{this.props.Item.ProcessMode ?
					<>
						<TextInput
							Id="Order"
							Value={this.props.Item.Order}
							Type="number"
							Step="0.001"
							RowClass="nomargin"
							Required={true}
							onChange={(value, id) => this.props.Item.collect(id, value)}
						/>
						<Selectize
							Id="ProviderId"
							Value={this.props.Item.ProviderId}
							List={toSelectList(this.props.getProvidersByProduct(this.props.Item.Product))}
							RowClass="nomargin"
							onChange={(value, id) => this.props.Item.collect(id, value)}
						/>
							<RemoveIconButton onClick={() => this.props.removeProduct(this.props.Item.ProductId)} />
					</>
					: <><span></span><span></span><span></span></>
				}
			</>
		)
	}
}
RequestProductItem = observer(RequestProductItem);
